<section class="tenant-header">
    <div (click)="routeToHome()" class="logo-wrap">
        <img class="company-img" src="{{ companyImage }}" alt="company logo" />
        <img
            [class]="productImage === '../../assets/img/ez-docs-logo-white.png' ? 'product-img ez-docs' : 'product-img'"
            src="{{ productImage }}"
            alt="digital product image"
        />
    </div>
</section>
